import type { PropositionDetails, Task } from "@dune/types";
import { Button, DataTable } from "@dune/ui";
import { Plus } from "lucide-react";
import React, { useState } from "react";
import { usePropositionTasks } from "../../../../api/queries/propositions.queries";
import { useTaskActions } from "../../../../stores/task.store";
import CreateManualTaskModal from "../modals/CreateManualTaskModal";
import { propositionTasksColumns } from "./tasksColumns";
import { useMe } from "../../../../api/queries/users.queries";

interface TasksTabProps {
	proposition: PropositionDetails;
}

export const TasksTab: React.FC<TasksTabProps> = ({ proposition }) => {
	const { data: tasks, isLoading, error } = usePropositionTasks(proposition.id);
	const { selectTask } = useTaskActions();
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const { me: user } = useMe();

	const handleTaskClick = (task: Task) => {
		selectTask(task.id.toString());
	};

	const handleCreateTask = () => {
		setIsCreateModalOpen(true);
	};

	if (error) return <div>Erreur lors du chargement des tâches.</div>;

	const isDuneRole = user?.role === "DUNE";

	return (
		<div className="h-full">
			<div className="flex items-center justify-between mb-2 w-full">
				<h2 className="text-lg text-text-main-blue font-semibold">Tâches</h2>
				{isDuneRole && (
					<Button
						onClick={handleCreateTask}
						size="sm"
						className="flex items-center gap-2"
					>
						<Plus size={16} />
						Créer une tâche
					</Button>
				)}
			</div>
			<DataTable
				data={tasks ?? []}
				columns={propositionTasksColumns}
				noResultsText="Aucune tâche trouvée"
				isLoading={isLoading}
				onRowClick={isDuneRole ? handleTaskClick : undefined}
				variant="static-clean"
			/>
			<CreateManualTaskModal
				open={isCreateModalOpen}
				onOpenChange={setIsCreateModalOpen}
				propositionId={proposition.id}
				onSuccess={() => {
					// Refresh tasks will happen automatically via query invalidation
				}}
			/>
		</div>
	);
};
